import { useTranslation } from 'react-i18next';
import { useShare } from 'src/hook/global/useShare';
import { GetWebSiteUrl } from 'src/utils/URLUtils';
import styles from './ButtonGroupSection.module.scss';

const ButtonGroupSection = () => {
    const { t } = useTranslation();
    const { share } = useShare();

    return (
        <div className={styles.section}>
            <button
                onClick={() => window.open(`${GetWebSiteUrl()}/about`, '_blank')}
                className={`secondaryButton ${styles.buttonGroups}`}>
                {t('About us')}</button>
            <button
                onClick={() => window.open(`${GetWebSiteUrl()}/privacy`, '_blank')}
                className={`secondaryButton ${styles.buttonGroups}`}>{t('Privacy')}</button>
            <button
                onClick={() => share(`WordUp \n ${GetWebSiteUrl()}`)}
                className={`secondaryButton ${styles.buttonGroups}`}>{t('Share')}</button>
        </div>
    );
};

export default ButtonGroupSection;